<div class="toast">
  <div class="header">
    <opac-icon [icon]="icon()"></opac-icon>

    <span>{{ title() | translate }}</span>

    <opac-button [showTooltip]="true" [opacTooltip]="'general.close' | translate" (click)="dismiss()">
      <opac-icon icon="close" slot="only-icon"></opac-icon>
    </opac-button>
  </div>

  <div class="content">
    <opac-icon [icon]="icon()"></opac-icon>

    <p>
      <ng-content></ng-content>
    </p>

    <opac-button [showTooltip]="true" [opacTooltip]="'general.close' | translate">
      <opac-icon icon="close" slot="only-icon"></opac-icon>
    </opac-button>
  </div>
</div>
